import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { WebLogo } from "../Icons";

const NavBar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const products = [
    {
      name: "Critical Care",
      path: "/products",
    },
    {
      name: "Glee Derma",
      path: "/products/glee-derma",
    },
    {
      name: "UroGlee",
      path: "/products/uroglee",
    },
  ];

  const renderNavLink = (path, label) => (
    <li className="relative">
      <Link
        to={path}
        // className={`text-[15px] text-black relative transition-all duration-300
        // ${
        //   isActive(path)
        //     ? "after:w-full"
        //     : "after:w-0 hover:after:w-full"
        // }
        // after:absolute after:left-0 after:-bottom-1 after:h-[3px]
        // after:bg-[#1F488E] after:transition-all after:duration-300`}
        className={`text-[15px] text-black flex items-center transition-all duration-300 relative 
          ${isActive(path) ? "after:right-0" : "after:right-full"} 
          after:absolute after:transition-all after:duration-300 after:h-1 after:rounded-[4px] 
          after:bg-gradient-to-r after:from-[#6aaeca] after:via-[#1F488E] after:to-[#727272] after:left-0 
          hover:after:right-0 after:-bottom-1`}

      >
        {label}
      </Link>
    </li>
  );

  return (
    <div className="shadow-md sticky top-0 z-50 bg-white">
      <nav className="flex justify-between items-center xl:max-w-[1364px] mx-auto px-5 py-4">

        {/* LOGO */}
        <Link
          to="/"
          className="flex items-center gap-2 font-bold text-[#9e9d9d]"
        >
          <WebLogo />
          <span className="max-sm:hidden">
            Glee
            <span className="text-[#1F488E] mx-1">Biotech</span>
            Ltd.
          </span>
        </Link>

        {/* MENU */}
        <ul
          className={`flex xl:gap-[55px] gap-[35px] items-center bg-white
          max-lg:fixed max-lg:top-0 max-lg:left-0 max-lg:w-full
          max-lg:h-screen max-lg:flex-col max-lg:justify-center
          transition-all duration-300
          ${isMenuOpen ? "max-lg:flex" : "max-lg:hidden"}`}
        >
          {renderNavLink("/", "Home")}
          {renderNavLink("/aboutus", "About Us")}

          {/* DROPDOWN */}
          <li
            className="relative "
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button
              className={`flex items-center gap-1 text-[15px] text-black relative
              ${location.pathname.includes("/products")
                  ? "after:w-full"
                  : "after:w-0 hover:after:w-full"
                }
             after:absolute after:transition-all after:duration-300 after:h-1 after:rounded-[4px] 
          after:bg-gradient-to-r after:from-[#6aaeca] after:via-[#1F488E] after:to-[#727272] after:left-0 
          hover:after:right-0 after:-bottom-1`}
            >
              Category
              <ChevronDown
                size={16}
                className={`transition-transform duration-300 ${isDropdownOpen ? "rotate-180" : ""
                  }`}
              />
            </button>

            {/* DROPDOWN MENU */}
            <div
              className={`absolute top-[45px] left-0 w-[300px]
              bg-white rounded-xl shadow-xl overflow-hidden
              border border-[#F2F2F2] transition-all duration-300
              ${isDropdownOpen
                  ? "opacity-100 visible translate-y-0"
                  : "opacity-0 invisible -translate-y-2"
                }`}
            >
              {products.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className="block px-10 py-4 text-[18px] text-[#333333]
                  hover:bg-gray-50 hover:text-[#1F488E]
                  border-b last:border-none transition-all duration-200 z-10"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </li>

          {renderNavLink("/contact", "Contacts Us")}
        </ul>

        {/* CALL BUTTON */}
        <div className="flex items-center gap-4">
          {/* <a
            href="tel:+91-124-4014-4675"
            className="max-sm:hidden px-7 py-3 rounded-full
            bg-gradient-to-r from-[#6AAECA] to-[#1F488E]
            text-white font-medium hover:scale-[1.02]
            transition-all duration-300"
          >
            Call Us
          </a> */}


          <div className="flex items-center gap-3">
            <a
              href="tel:+91-124-4014-4675"
              className="max-sm:hidden relative inline-block px-8 py-3 bg-gradient-to-r from-[#6AAECA] to-[#1F488E] hover:from-[#1F488E] hover:to-[#6AAECA] text-white rounded-full font-semibold hover:bg-[#2C5BB8] transform hover:scale-[1.01] transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Call Us
            </a>
            <div
              onClick={() => setMenuOpen(!isMenuOpen)}
              className="w-[35px] h-[25px] relative z-50 flex flex-col justify-between lg:hidden cursor-pointer"
            >
              <span
                className={`transition-all duration-300 ease-linear rounded-3xl
                ${isMenuOpen ? "rotate-[48deg] translate-y-[23px]" : ""} 
                bg-[#002347] w-full h-[4px]`}
              ></span>
              <span
                className={`transition-all duration-300 ease-linear rounded-3xl 
                ${isMenuOpen ? "opacity-0" : "bg-[#002347] w-3/4 h-[4px] ms-2"}`}
              ></span>
              <span
                className={`transition-all duration-300 ease-linear rounded-3xl 
                ${isMenuOpen ? "rotate-[-50deg] translate-y-[50%]" : ""} 
                bg-[#002347] w-full h-[4px]`}
              ></span>
            </div>
          </div>


          {/* MOBILE MENU */}
          {/* <div
            onClick={() => setMenuOpen(!isMenuOpen)}
            className="w-[35px] h-[25px] relative z-50 flex flex-col justify-between lg:hidden cursor-pointer"
          >
            <span
              className={`h-[4px] bg-[#002347] rounded-full transition-all duration-300
              ${isMenuOpen ? "rotate-45 translate-y-[10px]" : ""}`}
            ></span>

            <span
              className={`h-[4px] bg-[#002347] rounded-full transition-all duration-300
              ${isMenuOpen ? "opacity-0" : ""}`}
            ></span>

            <span
              className={`h-[4px] bg-[#002347] rounded-full transition-all duration-300
              ${isMenuOpen ? "-rotate-45 -translate-y-[10px]" : ""}`}
            ></span>
          </div> */}
        </div>
      </nav>
    </div>
  );
};

export default NavBar;